import { useEffect, useState } from 'react'

import type { PageInfo } from '../types'
import { usePageProps } from '../usePageProps'

type GamConfig = {
  pageInfo: PageInfo
  login?: { loginStatus: string }
  includePersonalisation?: boolean
}

type PageGamProps = {
  pageInfo: PageInfo
}

export const usePageGamConfig = ({ pageInfo }: PageGamProps) => {
  const [gamConfig, setGamConfig] = useState<GamConfig>()

  const { userAccessState } = usePageProps()
  const isLoggedIn = userAccessState?.userLoggedIn
  const loginStatus = isLoggedIn ? 'LoggedIn' : 'LoggedOut'

  useEffect(() => {
    setGamConfig({
      pageInfo,
      login: {
        loginStatus,
      },
      includePersonalisation: true,
    })
  }, [pageInfo, loginStatus])

  return gamConfig
}
